import { createOpenStore } from "stores/createOpenStore";
import type { RestrictedTable } from "@/components/main/datasets/AddToDatasetDialog";

export interface AddToDatasetOpen {
  tableIds: string[];
  label: string;
  isCatalogModel: boolean;
  restrictedTables: RestrictedTable[];
}

export const useAddToDatasetStore = createOpenStore<AddToDatasetOpen>();
